import { render } from "./RHIncidentsDashboard.vue?vue&type=template&id=05bbcc44&scoped=true"
import script from "./RHIncidentsDashboard.vue?vue&type=script&lang=js"
export * from "./RHIncidentsDashboard.vue?vue&type=script&lang=js"

import "./RHIncidentsDashboard.vue?vue&type=style&index=0&id=05bbcc44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05bbcc44"]])

export default __exports__